( function( $ ){
  var defaults = {
    onClearExclusive: function(exclusive){},
    onClearOthers: function(others){}
  };
  var methods = {
    init: function( aOptions ){
      var settings = $.extend ( {}, defaults, aOptions );
      return $(this).each( function(){
        console.log('mutuallyExclusive.init()');
        var $this = $( this ),
          data = $this.data('widget'),
          exclusiveInput = $this.find('input.exclusive'),
          otherInputs = $this.find('input, select, textarea').not('.exclusive');

        $this.settings = settings;

        exclusiveInput.bind('change', function(evt){
          $this.mutuallyExclusive('clearOthers', $(this));
        });
        otherInputs.bind('change', function(evt){
          $this.mutuallyExclusive('clearExclusive');
        });

        if ( !data ) {
          $this.data('settings', settings);
          $this.data('exclusiveInput', exclusiveInput);
          $this.data('otherInputs', otherInputs);
        }
      });
    },
    clearExclusive: function(){
      var $this = $(this),
          exclusiveInput = $this.data('exclusiveInput');
          otherInputs = $this.data('otherInputs');
      otherInputs.each(function(){
        if( $(this).prop('checked') || $(this).val() ){
          exclusiveInput.prop('checked', false);
        }
      });
      this.settings.onClearExclusive(exclusiveInput);
      $this.trigger('mutuallyExclusive:changed', [$this.data('exclusiveInput'), $this.data('otherInputs')]);
      $this.trigger('mutuallyExclusive:clearedExclusive', [exclusiveInput, otherInputs]);
    },
    clearOthers: function(exclusiveChanged){
      var $this = $(this); //referrs to plugin
      if( exclusiveChanged.prop('checked') ){
          var others = $this.find('input, select, textarea').not(exclusiveChanged);
          others.each(function(){
            if( $(this).prop('tagName') == 'INPUT' && ( $(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio' ) ){
              $(this).prop('checked', false);
            }else{
              $(this).val('');
            }
         });
        this.settings.onClearOthers(others);
        $this.trigger('mutuallyExclusive:changed', [$this.data('exclusiveInput'), $this.data('otherInputs')]);
        $this.trigger('mutuallyExclusive:clearedOthers', [$this.data('exclusiveInput'), $this.data('otherInputs')]);
      }
    }
  };

  $.fn.mutuallyExclusive = function( method ) {
    if ( methods[method] ) {
        return methods[ method ].apply(this, Array.prototype.slice.call(arguments, 1));
    }else if ( typeof method === 'object' || ! method) {
        return methods.init.apply(this, arguments);
    }else{
        $.error( 'Method '+method+' does not exist on jQuery.mutuallyExclusive' );
    }
  };
} ( jQuery ) );